import { Flex, Image, Loader, Text } from '@mantine/core';
import {
  ChatBubble,
  ChatBubbleHeader,
  ChatListenButton,
  ChatMessageMeta,
  ChatMessageTime,
  ChatSender,
} from '@packages/chat/ui';
import { memo } from 'react';
import type { CandidateInterviewChatMessageProps } from '../types';
import s from './candidateInterviewChatMessage.module.scss';

export const CandidateInterviewChatMessage = memo(
  ({
    time,
    sender,
    message,
    contentType,
    audioUrl,
    fileName = '',
    handleOpenModal,
    senderName = 'CYNTHIA',
    status,
    transcription,
    images = [],
  }: CandidateInterviewChatMessageProps) => {
    const isPending = status === 'pending';
    const isFailed = status === 'failed';
    const isImageMessage = contentType === 'image';
    const isTextMessage = contentType === 'text' || contentType === 'template';

    return (
      <ChatBubble side={sender}>
        <ChatBubbleHeader side={sender}>
          {isPending && (
            <Loader style={{ alignSelf: 'center' }} size='sm' color='blue' />
          )}
          <Flex gap={8} align='center'>
            <ChatListenButton
              label='Прослушать'
              audioUrl={audioUrl}
              onListen={url => handleOpenModal(url, fileName)}
            />
          </Flex>

          <ChatMessageMeta side={sender}>
            <ChatMessageTime time={time} />
            <ChatSender name={senderName} />
          </ChatMessageMeta>
        </ChatBubbleHeader>
        {transcription && <Text size='sm'>{transcription}</Text>}
        {isTextMessage && (
          <Flex align='center'>
            <Text size='sm'>{message}</Text>
          </Flex>
        )}
        {isFailed && (
          <Text size='sm' c='red'>
            Сообщение не доставлено
          </Text>
        )}
        {isImageMessage && images.length > 0 && (
          <Flex direction='column' gap={8} className={s.images}>
            {images.map((image, index) => (
              <Image
                key={`${image.absolutePath}-${index}`}
                src={image.absolutePath}
                alt={image.name}
                fit='contain'
                radius='sm'
                className={s.image}
              />
            ))}
          </Flex>
        )}
      </ChatBubble>
    );
  }
);
